
import React from 'react';
import { Button } from '@/components/ui/button';
import { useToast } from '@/hooks/use-toast';
import { DownloadIcon, MailIcon } from 'lucide-react';

interface ActionButtonsProps {
  goToPreviousStep: () => void;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({ goToPreviousStep }) => {
  const { toast } = useToast();

  const handleDownloadPDF = () => {
    // In a real application, this would generate a PDF
    toast({
      title: "PDF Generation",
      description: "Your estimate has been downloaded as a PDF.",
    });
  };

  const handleEmailResults = () => {
    // In a real application, this would send an email
    toast({
      title: "Email Sent",
      description: "Your estimate has been sent to your email.",
    });
  };

  return (
    <div className="flex flex-col sm:flex-row gap-3 justify-between">
      <Button variant="outline" onClick={goToPreviousStep}>
        Back to Maintenance
      </Button>
      <div className="flex gap-2">
        <Button variant="outline" onClick={handleDownloadPDF} className="flex items-center gap-1">
          <DownloadIcon className="h-4 w-4" />
          Download PDF
        </Button>
        <Button onClick={handleEmailResults} className="flex items-center gap-1">
          <MailIcon className="h-4 w-4" />
          Email Results
        </Button>
      </div>
    </div>
  );
};

export default ActionButtons;
